export default __webpack_public_path__ + "static/media/FRAX-QUICK.9114dd21.png";